// 化纤行业知识中心：面向公开检索的基础主题。
// 涉及产品指标、法规或工艺参数时，应以企业技术协议及适用的现行标准为准。
export const KNOWLEDGE_UPDATED_AT = '2026-07-28'

export const KNOWLEDGE_TOPICS = [
  {
    slug: 'polyester-fiber-basics',
    category: '材料基础',
    title: '涤纶是什么：原料、性能与常见应用',
    summary: '涤纶通常指聚对苯二甲酸乙二醇酯（PET）纤维，是化纤产业中应用广泛的合成纤维。它由聚酯熔体纺丝并经牵伸、定型等后加工形成，可制成短纤、长丝及多种差别化产品。',
    paragraphs: ['涤纶以强度较高、耐磨、保形性较好和易护理为主要特点，常用于服装、家纺、产业用纺织品以及复合材料增强等场景。其吸湿性相对较低，产品开发时通常会通过截面设计、改性、混纺或后整理改善舒适性和功能性。', '判断具体产品是否适用，不能只看“涤纶”这一名称，还应结合纤度、孔数、截面、光泽、卷曲、染色性能、强伸指标和下游加工要求综合确认。'],
    points: ['产业链通常从 PTA、MEG 等原料延伸至聚酯、切片、纺丝及织造染整。', '长丝和短纤的后加工路径、应用和考核指标并不相同。', '产品规格应以供需双方技术协议及适用标准为准。'],
    faqs: [{ q: '涤纶和聚酯是一回事吗？', a: '在纤维产品语境中，涤纶通常是以 PET 为主的聚酯纤维商品名称；“聚酯”则还可泛指相关高分子材料和产品。' }, { q: '涤纶适合做哪些产品？', a: '可用于服装、家纺、装饰和产业用纺织品，具体取决于纤维结构、纱线工艺和后整理要求。' }]
  },
  {
    slug: 'poy-dty-fdy-differences',
    category: '材料基础',
    title: 'POY、DTY、FDY 的区别与选用',
    summary: 'POY、DTY、FDY 都是涤纶长丝的常见类别：POY 是预取向丝，DTY 是经加弹形成的变形丝，FDY 是纺丝过程中充分取向的全拉伸丝。三者在结构、手感和下游加工方式上不同。',
    paragraphs: ['POY 通常作为加弹、牵伸变形等工序的原丝；DTY 具有卷曲和蓬松感，常用于针织和仿弹性面料；FDY 条干较均匀、表面相对平整，常用于织造及对外观有要求的面料。', '选型时应同时确认纤度、孔数、消光等级、网络度、油剂、断裂强度和伸长等指标，并做下游试织或试染验证。'],
    points: ['POY 的主要定位是后加工原丝，不宜与成品丝的使用场景混同。', 'DTY 的卷曲性能影响织物弹性、覆盖性和手感。', 'FDY 的外观与染色一致性需结合批次管理控制。'],
    faqs: [{ q: 'POY 能直接用于织造吗？', a: '是否可直接使用取决于产品设计和设备工艺；其常见用途仍是作为后加工原丝。' }, { q: 'DTY 一定比 FDY 有弹性吗？', a: 'DTY 因变形卷曲通常具有更明显的蓬松和弹性表现，但实际效果仍受规格、织物组织与后整理影响。' }]
  },
  {
    slug: 'pta-meg-pet-relationship',
    category: '材料基础',
    title: 'PTA、MEG、PET 与涤纶的关系',
    summary: 'PTA（精对苯二甲酸）与 MEG（乙二醇）是生产 PET 的常见基础原料；PET 经熔融纺丝和后加工后可制成涤纶纤维。它们共同构成聚酯—涤纶产业链的关键环节。',
    paragraphs: ['在生产管理中，原料质量、配比、聚合工艺和终端基团控制会影响聚酯熔体及后续切片、纺丝产品的稳定性。原料行情、装置运行和下游需求变化也会传导至聚酯及涤纶产品。', '分析产业链时，应将原料价格、加工差、库存、开工、订单和出口等指标放在同一时间维度中观察，避免只用单一价格判断景气。'],
    points: ['PTA、MEG 是原料，PET 是聚合物，涤纶是 PET 的重要纤维形态。', '不同企业的原料路线和装置配置可能存在差异。', '行业数据必须注明统计时间、口径和数据来源。'],
    faqs: [{ q: 'PET 只能做纤维吗？', a: '不是。PET 还可用于瓶片、膜材和工程应用等，具体取决于牌号和加工路线。' }, { q: '原料价格上涨会立刻传导到长丝价格吗？', a: '不一定，还会受到库存、供需、订单、利润和市场预期等因素影响。' }]
  },
  {
    slug: 'polyester-chip-guide',
    category: '材料基础',
    title: '聚酯切片的类型、用途与关注指标',
    summary: '聚酯切片是聚酯熔体经切粒得到的粒料，可按用途分为纤维级、瓶级、膜级等。纤维生产中，切片质量会影响熔体稳定性、纺丝连续性和成品质量。',
    paragraphs: ['切片选用需关注牌号、黏度或特性黏度、端基、色相、灰分、水分以及批次稳定性等信息。储存和输送环节还应避免受潮、污染和混料，确保进料状态可追溯。', '不同下游对切片性能的要求并不完全相同。采购或替换原料前，应通过小试或中试验证纺丝、加弹、织造和染整的整体适配性。'],
    points: ['按用途管理牌号，避免将不同用途的切片混用。', '水分和污染控制会直接影响加工稳定性。', '建立批次记录有助于异常质量追溯。'],
    faqs: [{ q: '切片受潮会有什么风险？', a: '受潮可能影响熔融加工稳定性和产品质量，应按企业工艺要求进行干燥与密封管理。' }, { q: '切片指标越高越好吗？', a: '不是。指标要与产品用途、设备能力和技术协议匹配。' }]
  },
  {
    slug: 'recycled-polyester-guide',
    category: '绿色低碳',
    title: '再生涤纶：来源、鉴别与质量管理',
    summary: '再生涤纶通常以回收 PET 资源为原料，经分选、清洗、再加工或化学循环等路径制成再生聚酯及其纤维产品。它的价值在于提高资源循环利用效率，但质量和可追溯管理尤为重要。',
    paragraphs: ['企业应区分回收来源、再生路线、再生含量声明和产品最终性能。对于食品接触、出口认证或品牌订单，还需依据客户要求核查链路文件、检测报告和认证规则。', '再生属性不等于所有性能天然一致。原料杂质、热历史和加工控制都会影响颜色、黏度、纺丝稳定性及最终纤维品质。'],
    points: ['建立回收来源、批次和再生含量的证据链。', '再生料与原生料的配比应经过产品验证。', '宣传再生属性时，应避免超出可核验的证据范围。'],
    faqs: [{ q: '再生涤纶一定比原生涤纶差吗？', a: '不一定。实际质量取决于原料控制、再生工艺、配方和质量管理。' }, { q: '如何判断再生含量？', a: '应依据适用的检测、认证或供应链追溯要求，并保留相应证据。' }]
  },
  {
    slug: 'nylon-6-nylon-66',
    category: '材料基础',
    title: '锦纶 6 与锦纶 66 的主要区别',
    summary: '锦纶是聚酰胺纤维的常用名称。锦纶 6 与锦纶 66 的聚合单体和分子结构不同，因此在熔点、耐热、强度、染色和加工窗口等方面会呈现差异。',
    paragraphs: ['两类材料都具有较好的耐磨性和韧性，常用于服装、袜品、运动、工业丝及工程用途。具体性能差异还会受到纤维规格、改性、牵伸和后整理的影响。', '替代使用时，不应只按名称判断；应围绕目标产品的热定型、染色、力学性能、耐久性和成本要求完成验证。'],
    points: ['锦纶 6、锦纶 66 的原料和聚合路线不同。', '不同产品牌号的加工温度窗口需按供应商资料确认。', '替代材料要在下游工艺中完成验证。'],
    faqs: [{ q: '锦纶和尼龙有什么关系？', a: '“尼龙”是聚酰胺材料的常见称呼，纤维领域通常称为锦纶。' }, { q: '锦纶 66 一定优于锦纶 6 吗？', a: '没有绝对优劣，应根据用途、性能要求、工艺和成本综合选择。' }]
  },
  {
    slug: 'spandex-fiber-guide',
    category: '材料基础',
    title: '氨纶的性能、使用要点与混纺思路',
    summary: '氨纶是以高弹性为主要特征的聚氨酯弹性纤维，常与涤纶、锦纶、棉或粘胶等纤维交织或包覆使用，以改善织物的弹性、贴合性和回复性。',
    paragraphs: ['氨纶在使用中需关注旦数、拉伸倍率、张力控制、包覆方式以及热处理条件。过度拉伸、温度不匹配或储存不当都可能影响弹性保持和加工稳定性。', '设计弹性面料时，要将氨纶比例与织物组织、纱线结构、染整及成衣穿着要求一起评估，避免只追求高含量而牺牲手感或耐久性。'],
    points: ['氨纶常作为功能性组分与其他纤维配合使用。', '加工过程重点控制张力、倍率与热条件。', '弹性回复应以成品测试结果评价。'],
    faqs: [{ q: '氨纶含量越高弹性越好吗？', a: '不一定。织物结构和加工工艺同样决定最终弹性及回复表现。' }, { q: '氨纶能否高温处理？', a: '需遵循具体产品资料和工艺要求，避免超出材料适用的热处理窗口。' }]
  },
  {
    slug: 'viscose-fiber-guide',
    category: '材料基础',
    title: '粘胶纤维的特点与应用注意事项',
    summary: '粘胶纤维属于再生纤维素纤维，具有较好的吸湿性和柔软手感，可用于服装、家纺和非织造等领域。其湿态性能、尺寸稳定性和染整适应性需要在产品设计中重点考虑。',
    paragraphs: ['粘胶产品的差异通常与原料、纺丝路线、纤维长度、细度和后处理有关。与合成纤维混纺时，可利用不同纤维在手感、吸湿和强度方面的互补性。', '生产与采购时，应按用途关注断裂强度、伸长、毛羽、白度、回潮及有害物质控制等指标，并结合织造、染整和成衣洗护要求进行验证。'],
    points: ['粘胶的舒适性优势与湿态性能控制需要平衡。', '混纺比例应结合最终用途确定。', '环保合规需覆盖原料、生产与产品交付链路。'],
    faqs: [{ q: '粘胶是不是天然纤维？', a: '粘胶以天然来源的纤维素为原料，但经化学加工再生成纤维，通常归为再生纤维素纤维。' }, { q: '粘胶适合和涤纶混纺吗？', a: '常见且可行，但需根据产品目标协调舒适性、强度、缩水和染整表现。' }]
  },
  {
    slug: 'polypropylene-fiber-guide',
    category: '材料基础',
    title: '丙纶的特点与典型使用场景',
    summary: '丙纶是以聚丙烯为主要原料的合成纤维，密度低、耐化学性较好，并可用于无纺布、地毯、绳带、过滤和产业用纺织品等场景。',
    paragraphs: ['丙纶的染色、耐热和耐候表现与纤维改性、色母、稳定剂和应用环境有关。对户外、医疗卫生、过滤等细分用途，应按实际工况选择对应的材料体系与检测项目。', '在产品沟通中，应明确是否需要亲水、抗紫外、阻燃、抗菌等功能，并将功能声明与测试方法、适用范围绑定。'],
    points: ['低密度是丙纶的重要材料特征。', '功能化常依赖改性、母粒或后加工方案。', '特殊用途需要按实际使用场景验证。'],
    faqs: [{ q: '丙纶为什么常用于无纺布？', a: '它适合多种纺粘、熔喷等加工路径，且材料特性可通过工艺和改性进行调节。' }, { q: '丙纶能染色吗？', a: '可以，但工艺路线和效果需与材料特性匹配，色母着色是常见方案之一。' }]
  },
  {
    slug: 'acrylic-fiber-guide',
    category: '材料基础',
    title: '腈纶的性能与仿毛产品开发',
    summary: '腈纶通常以聚丙烯腈为主要成分，具有蓬松、柔软和仿毛外观等特点，常用于针织、毛毯、家纺及户外保暖产品。',
    paragraphs: ['腈纶产品开发常关注纤维细度、卷曲、长度、可染性和抗起球表现。与羊毛、粘胶或其他纤维混纺时，可以在保暖性、手感、成本和易护理性之间进行平衡。', '毛型产品的最终表现不只由原料决定，还受纺纱、织造、起毛、定型和洗护条件影响，应通过成品评估来确认方案。'],
    points: ['卷曲和蓬松度影响腈纶的仿毛风格。', '混纺有助于获得差异化手感和性能。', '抗起球和尺寸稳定性应在成品端验证。'],
    faqs: [{ q: '腈纶能替代羊毛吗？', a: '可在部分场景提供仿毛风格，但两者的天然属性、手感和性能并不完全相同。' }, { q: '腈纶适合做夏季面料吗？', a: '需结合纱线结构和织物设计判断，腈纶更常用于需要蓬松和保暖感的产品。' }]
  },
  {
    slug: 'differentiated-fibers',
    category: '材料基础',
    title: '差别化纤维：如何从需求定义产品',
    summary: '差别化纤维是在常规纤维基础上，通过异形截面、细旦化、复合、功能改性、色彩或物理结构设计形成的产品。其核心不是“参数更多”，而是解决具体下游问题。',
    paragraphs: ['常见开发目标包括吸湿排汗、仿棉仿毛、凉感、抗菌、阻燃、抗紫外、低熔点粘合、导电和高强耐磨等。每一项功能都应明确适用边界、测试方法与耐久性要求。', '从需求到产品的路径应包括：场景定义、目标指标、材料与工艺方案、小试、中试、下游验证和批量质量控制。'],
    points: ['先定义终端场景，再选择纤维结构和功能路线。', '功能指标要可测试、可交付、可复核。', '差别化产品需重视批次稳定性和下游验证。'],
    faqs: [{ q: '异形截面一定能提升吸湿排汗吗？', a: '截面设计可改善导湿路径，但最终效果还与纤维表面、纱线和织物结构相关。' }, { q: '功能纤维如何避免夸大宣传？', a: '应使用与测试方法、样品条件和耐久周期相匹配的表述。' }]
  },
  {
    slug: 'yarn-count-units',
    category: '质量与工艺',
    title: 'dtex、tex、den：纤维纱线线密度单位怎么换算',
    summary: 'tex、dtex 和 den 都用于表示纤维或纱线的线密度。tex 表示每 1000 米的克数，dtex 表示每 10000 米的克数，den 表示每 9000 米的克数。',
    paragraphs: ['常用换算关系为：1 tex = 10 dtex；1 den 约等于 1.111 dtex；1 dtex 约等于 0.9 den。单位本身只反映线密度，不直接代表强度、手感或品质。', '规格沟通时还应同时说明单丝/复丝、孔数、捻度、光泽、网络度和用途，避免因单位或表达方式不同造成误解。'],
    points: ['换算前先确认对象是单丝、复丝还是纱线。', '线密度需要与孔数、截面和用途一起解释。', '技术协议应统一使用单位和允差表达。'],
    faqs: [{ q: 'dtex 数值越大代表什么？', a: '在同一对象和表达方式下，数值越大通常表示单位长度质量越大，即更粗。' }, { q: 'den 和旦数是同一个概念吗？', a: '行业中“旦”常用来指 den，但正式文件应明确单位写法和换算依据。' }]
  },
  {
    slug: 'draw-ratio-and-orientation',
    category: '质量与工艺',
    title: '牵伸倍数与取向：为什么影响纤维性能',
    summary: '牵伸是化纤后加工中的重要环节。通过对丝束或长丝施加受控拉伸，可改变大分子取向和结晶状态，从而影响强度、伸长、模量、热收缩及染色表现。',
    paragraphs: ['牵伸倍数并非越高越好。过高或波动过大可能增加断丝、毛丝、条干不匀或性能不稳定风险；过低又可能无法达到预期取向和力学性能。', '工艺设定应综合原丝状态、温度、速度、设备张力、油剂和目标规格，并通过在线数据与成品检测共同闭环。'],
    points: ['牵伸会影响分子取向和最终力学性能。', '温度、速度和张力需要协同控制。', '应通过趋势数据识别异常，而非只看单点结果。'],
    faqs: [{ q: '牵伸倍数提高后强度一定上升吗？', a: '通常会产生影响，但实际结果还受材料、热条件和设备稳定性限制。' }, { q: '如何判断牵伸是否稳定？', a: '可结合断头、张力、速度、条干及成品强伸和收缩等数据综合判断。' }]
  },
  {
    slug: 'moisture-regain-and-comfort',
    category: '质量与工艺',
    title: '回潮率、吸湿性与织物舒适性',
    summary: '回潮率用于描述纤维在规定条件下所含水分与干燥质量的关系，是纺织材料的基础物理指标之一。它与吸湿、导湿、静电和加工状态有关，但不等同于穿着舒适性的全部。',
    paragraphs: ['不同纤维的吸湿特性不同。产品舒适性还受截面、表面处理、纱线结构、织物组织、克重、后整理和环境条件共同影响。', '企业在检测和对外沟通时，应说明测试的调湿条件、方法和样品状态，避免脱离条件比较不同产品的回潮数据。'],
    points: ['回潮率是基础指标，不可单独替代舒适性评价。', '导湿、透气、快干等性能需要使用相应测试方法。', '比较数据时应保持测试条件一致。'],
    faqs: [{ q: '回潮率高就一定更舒适吗？', a: '不一定。舒适性还受到织物结构和使用环境等多种因素影响。' }, { q: '合成纤维如何改善湿热舒适性？', a: '可通过异形截面、细旦化、亲水改性、纱线和织物设计、后整理等多种方式协同优化。' }]
  },
  {
    slug: 'melt-spinning-process',
    category: '质量与工艺',
    title: '熔融纺丝流程与关键控制点',
    summary: '熔融纺丝通常包括原料准备、熔融输送、计量、过滤、纺丝组件、冷却成形、上油、卷绕及后加工等环节。稳定的工艺窗口是保证纤维连续生产和质量一致性的基础。',
    paragraphs: ['生产中应关注熔体温压、计量泵、过滤压差、组件状态、侧吹风、上油、张力和卷绕等过程信号。单个变量异常往往会通过丝条、毛丝、断头或成品指标反映出来。', '质量改善宜采用“异常现象—过程数据—设备状态—原料批次—验证结果”的闭环方法，避免仅凭经验调整单一参数。'],
    points: ['过程稳定性直接影响成形和卷绕质量。', '过滤与组件状态需要纳入预防性维护。', '在线数据与实验室检测应建立对应关系。'],
    faqs: [{ q: '为什么侧吹风重要？', a: '冷却条件会影响丝条成形和结构均匀性，应按品种和设备条件进行控制。' }, { q: '出现断头应先查哪里？', a: '建议按安全规程，从原料、熔体、组件、冷却、上油、张力和卷绕等环节逐项排查。' }]
  },
  {
    slug: 'polyester-dyeing-guide',
    category: '质量与工艺',
    title: '涤纶染色：影响色光与色牢度的因素',
    summary: '涤纶染色通常需要结合分散染料、设备条件和热处理工艺实现。颜色一致性与色牢度并非只由染料决定，还与前处理、浴比、温度曲线、助剂、清洗和定型等因素相关。',
    paragraphs: ['批次间色差控制需关注原料批次、坯布状态、染料配方、设备重复性和检测条件。建立标准样、留样和配方版本管理，有助于提高复现性。', '对于深色、高牢度或功能面料，还应根据客户要求评估摩擦、耐洗、耐汗渍、耐光等项目，并明确测试条件。'],
    points: ['染色一致性需要原料、工艺和检测的共同控制。', '配方与工艺参数应建立版本和批次记录。', '色牢度项目应与具体用途和客户标准匹配。'],
    faqs: [{ q: '同一配方为什么会有色差？', a: '原料、设备状态、温度曲线、浴比和检测条件等都可能造成差异。' }, { q: '色牢度只看耐洗吗？', a: '不是。应按产品用途选择耐摩擦、耐汗渍、耐光等对应项目。' }]
  },
  {
    slug: 'fiber-quality-indicators',
    category: '质量与工艺',
    title: '化纤质量指标：强度、伸长、条干与毛丝如何理解',
    summary: '化纤质量评价通常包含规格、力学性能、外观和加工性能等维度。强度、伸长、条干、毛丝、卷曲、色泽及网络等指标分别反映不同特性，不能用单一指标替代整体质量判断。',
    paragraphs: ['指标的目标值应与产品规格、下游工艺和客户协议一致。例如，织造对毛丝和条干敏感，加弹对原丝均匀性和网络状态敏感，产业用丝则更关注力学和耐久性能。', '质量管理应同时看平均值、离散度、趋势和批间一致性。只有平均值合格而波动过大，仍可能给下游带来加工风险。'],
    points: ['按用途建立质量指标组合，而非追求单项最大值。', '平均值与离散度同样重要。', '检验方法、抽样规则和判定依据需明确记录。'],
    faqs: [{ q: '断裂强度越高越好吗？', a: '不一定。过高或不匹配的强度、伸长组合可能影响后续加工和织物风格。' }, { q: '如何看待批间波动？', a: '应结合过程能力、客户敏感指标和历史趋势评估，并追溯原料与工艺变更。' }]
  },
  {
    slug: 'chemical-fiber-energy-management',
    category: '绿色低碳',
    title: '化纤企业如何开展能效管理',
    summary: '化纤能效管理的重点是建立“能源介质—工序—设备—产品—班组”的数据链路，用可比口径识别异常消耗与改善机会，而不是只汇总月度总能耗。',
    paragraphs: ['可从电、蒸汽、天然气、压缩空气、冷却水等介质入手，将计量数据与产量、品种、开机率、环境和设备状态关联。单位产品能耗应清晰定义边界、折标方式和统计周期。', '改善项目宜遵循基线建立、异常定位、措施验证、收益核算和持续监测的闭环，并由生产、设备、能源和财务共同确认口径。'],
    points: ['分项计量是发现能耗问题的基础。', '单位产品能耗必须标明边界和统计口径。', '节能效果应通过基线与持续数据复核。'],
    faqs: [{ q: '总能耗下降就代表能效提升吗？', a: '不一定。还需结合产量、产品结构、开机率和统计边界判断单位产品能耗。' }, { q: '优先从哪些设备入手？', a: '可先关注高耗能、长运行时间、波动大或故障频发的系统，并结合现场审计确定优先级。' }]
  },
  {
    slug: 'predictive-maintenance',
    category: '数字化应用',
    title: '化纤设备预测性维护的实施路径',
    summary: '预测性维护是通过状态监测、历史故障、工艺数据和模型分析识别设备劣化趋势，在故障发生前安排检修。其目标是降低非计划停机和质量损失，而非替代必要的点检与预防维护。',
    paragraphs: ['试点可从关键机组、泵、风机、压缩机、卷绕或公用工程设备中选择停机损失高、故障机理相对清晰且可获取数据的对象。传感器数据需与工单、备件、工艺与质量事件打通。', '项目评价应关注预警准确性、提前量、误报漏报、停机减少、维修成本和安全风险变化，并持续迭代阈值或模型。'],
    points: ['先选高价值、数据可得、故障可解释的设备试点。', '数据必须与维修工单和现场处置闭环。', '预警模型的价值要用业务结果验证。'],
    faqs: [{ q: '装了传感器就是预测性维护吗？', a: '不是。还需要数据治理、故障机理、预警规则或模型，以及可执行的维修闭环。' }, { q: '如何减少误报？', a: '结合工况、历史故障、现场复核和阈值迭代，避免脱离设备运行条件做单点判断。' }]
  },
  {
    slug: 'chemical-fiber-safety-environment',
    category: '绿色低碳',
    title: '化纤生产的安全与环保数据管理',
    summary: '化纤生产的安全环保管理需要把风险点、监测数据、报警、巡检、作业许可、隐患整改和应急处置连接成可追溯闭环。数字化系统应服务于现场管控，而非只做展示。',
    paragraphs: ['企业应根据自身工艺和适用法规识别重点风险，包括危险化学品、压力容器、可燃物、粉尘、废气、废水及固废等。监测设备、报警阈值和处置流程需与现场制度一致。', '对外披露环境或减排信息时，应说明核算边界、统计周期、方法、数据来源及审阅状态，避免使用无法复核的绝对化表述。'],
    points: ['安全环保数据要与责任人、时限和整改结果闭环。', '报警阈值与处置流程必须经过现场确认。', '环境数据披露应具备边界、方法和来源说明。'],
    faqs: [{ q: '可视化大屏能替代现场巡检吗？', a: '不能。大屏可以辅助识别和追溯，现场巡检与制度执行仍是基础。' }, { q: '如何提高环保数据可信度？', a: '统一计量、校验、采集、审核和留档规则，并清晰标注统计口径。' }]
  }
]

export function findKnowledgeTopic (slug) {
  return KNOWLEDGE_TOPICS.find(item => item.slug === slug)
}



// WEBPACK FOOTER //
// ./src/data/knowledge-topics.js